<template>
    <div class="wrap">
        <!--  -->
        <div class="title">
            <el-breadcrumb>
                <el-breadcrumb-item>优客码</el-breadcrumb-item>
                <el-breadcrumb-item>激活管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="main">
            <el-card>
                <el-row :gutter="10" class="index-head">
                    <el-col :span="4">
                        <el-input placeholder="激活人" v-model="activename" clearable> </el-input>
                    </el-col>
                    <el-col :span="4">
                        <el-select v-model="activeValue" placeholder="选择活动">
                            <el-option v-for="item in active_idlist" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="4">
                        <el-select v-model="province_id" placeholder="请选择省份" autocomplete="off">
                            <el-option :label="value" :value="value" v-for="(value, key, index) in GLOBALArealist['province_list']" :key="index"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="4">
                        <el-select v-model="city_id" placeholder="请选择市区">
                            <el-option :label="value" :value="value" v-for="(value, key, index) in GLOBALArealist['city_list']" :key="index"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="4">
                        <el-select v-model="statusValue" placeholder="状态">
                            <el-option v-for="item in GLOBALState.activation_options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                    </el-col>

                    <el-col :span="4">
                        <el-button type="primary" @click="handleButton(1)"> 搜 索 </el-button>
                        <el-button @click="handleButton(4)"> 重 置 </el-button>
                    </el-col>
                </el-row>
                <div class="table-content">
                    <el-table :data="list" border v-loading="listLoading">
                        <el-table-column label="id" prop="act_id"></el-table-column>
                        <el-table-column label="活动名称" prop="rebate_name"></el-table-column>
                        <el-table-column label="激活人" prop="agent_name"></el-table-column>
                        <el-table-column label="所在省市" prop="province_name"></el-table-column>
                        <el-table-column label="所在城市" prop="city_name"></el-table-column>
                        <!--   <el-table-column label="激活人姓名"
                         prop="agent_name"></el-table-column> -->

                        <el-table-column label="地理位置" prop="id">
                            <template slot-scope="scope">
                                <span style="color: #409eff" @click="handleButton(2, scope.row.id)">查看地理位置</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" prop="status">
                            <template slot-scope="scope">
                                {{ scope.row.is_active == 0 ? "异常" : "正常" }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" @click="handleButton(3, scope.row.agent_id)">数据统计</el-button>

                                <!-- <el-button type='text' v-if="scope.row.status==0"
                       @click="handleButton(6,scope.row)">编辑</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-card>
        </div>
        <!-- 分页 -->
        <pagination v-if="list.length > 0" :total="total" :pageNum="pageNum" :pageSize="pageSize" @pageChange="pageChange" />
        <div v-if="authordata">
            <chartdata @closeModel="initModel(1)" :title="datatitle"></chartdata>
        </div>
        <div v-if="geologicalVisible">
            <geological @closeModel="initModel(2)" :data_list="data_list" :details_id="details_id"></geological>
        </div>
    </div>
</template>

<script>
import { getactivelist, activationList, getgeo } from "@/api/erweima/index";
import pagination from "@/components/pagination/index.vue";
import chartdata from "./common/datachart.vue";
import geological from "./common/geological.vue";
export default {
    props: {},
    data() {
        return {
            activeValue: "",
            activename: "",
            province_id: "",
            city_id: "",
            active_idlist: [],
            statusValue: "",
            list: [],
            pageSize: 5,
            pageNum: 1,
            total: 0,
            listLoading: false,
            geologicalVisible: false,
            authordata: false,
            details_id: "",
            data_list: {},
            datatitle: "",
        };
    },
    mounted() {
        this.getactivelist_(); ///apirebate/system/rebateshoplist
        this.getactivationList(); ///apirebate/system/rebateshoplist
    },
    methods: {
        initModel(num) {
            if (num == 1) {
                this.authordata = false;
            } else {
                this.geologicalVisible = false;
            }
        },

        handleButton(key, row) {
            switch (key) {
                case 1:
                    this.pageNum = 0;
                    this.getactivationList();
                    break;
                case 4:
                    this.pageNum = 0;
                    this.activeValue = "";
                    this.activename = "";
                    this.province_id = "";
                    this.city_id = "";
                    this.statusValue = "";
                    this.getactivationList();
                    break;
                case 2:
                    this.details_id = row;
                    this.getgeo_(row);
                    break;
                case 3:
                    this.authordata = true;
                    this.datatitle = "数据统计";
                    this.$setSessionStorage("agent_id", row);
                    break;

                default:
                    break;
            }
        },
        pageChange(page) {
            this.pageSize = page._pageSize;
            this.pageNum = page._currentPage;
            this.getactivationList();
        },
        getgeo_(id) {
            this.$message.success({ message: "正在获取地理位置" });
            let par = { id: id };
            getgeo(par).then((res) => {
                if (res.code == 1) {
                    this.data_list = res.data.list;
                    this.geologicalVisible = true;
                } else {
                    this.$message.error({ message: res.msg });
                }
            });
        },
        getactivelist_() {
            this.listLoading = true;
            let par = {
                token: this.$getSessionStorage("token"),
                limit: 0,
                opt_id: this.$getSessionStorage("userid"),
            };
            getactivelist(par)
                .then((res) => {
                    this.listLoading = false;
                    if (res.code == 1) {
                        this.active_idlist = res.data.list;
                    } else {
                        this.$message.error({ message: res.msg });
                    }
                })
                .catch((err) => {});
        },
        //列表
        getactivationList() {
            this.listLoading = true;
            let par = {
                token: this.$getSessionStorage("token"),
                agent_name: this.activename,
                rebate_id: this.activeValue,
                opt_id: this.$getSessionStorage("userid"),
                province_name: this.province_id,
                city_name: this.city_id,
                is_active: this.statusValue,
                offset: this.pageNum,
                limit: this.pageSize,
            };
            activationList(par)
                .then((res) => {
                    this.listLoading = false;
                    if (res.code == 1) {
                        this.list = res.data.list;
                        this.total = parseInt(res.data.count);
                    } else {
                        this.$message.error({ message: res.msg });
                    }
                })
                .catch((err) => {});
        },
    },
    components: {
        pagination,
        chartdata,
        geological,
    },
};
</script>

<style lang="scss" scoped>
.index-head{
    padding: 16px 0;
}
 .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        font-size: 20px;
        color: #000000;
        width: 100%;
        padding: 15px 32px;
    }
.main {
        min-width: 1200px;
        margin: 20px;
           .el-card {
        min-height: 780px;
    }
}
</style>